import React from 'react'
import {Box,Typography,Button} from '@mui/material';
import HeroBannerImage from "../assets/images/gymImage.jpg"
function HeroBanner() {
  return (
    <Box  sx={{ mt :{lg: '212px' , xs:'70px'}, ml:{sm: '50px'} }} position="relative" p="20px">
      <Typography color="#FF2625" fontWeight={600} fontSize="26px">
           Fitness Mania
      </Typography>
      <Typography fontWeight={700} sx={{fontSize :{lg :'54px' ,sm:'40px'}}} mb="23px" mt="30px">
        Sweat, Smile <br />  And Repeat
       </Typography>
      <Typography fontSize="22px" lineHeight="35px" mb={3}>
         Check out the most effective exercies
      </Typography>

      <Button variant="contained" color="error" href="#exercises" sx={{backgroundColor: '#ff2625' , padding: '10px'}}>
         Explore Exercises
      </Button>
      <Typography fontWeight={700} fontSize="200px"color="#ff2625" sx={{ opacity:0.1 ,display:{lg:'block',xs:'none'}}}
      >
        Exercises
        </Typography>
      <img src={HeroBannerImage} alt="banner" className='hero-banner-img'/>
    </Box>
  )
}

export default HeroBanner